module.exports = __webpack_public_path__ + "static/img/xcx_zy.4af5ea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xcx_zy.jpg
// module id = Ns+s
// module chunks = 1